<template>
  <div id="home-page">
    <!-- 大赛流程 -->
    <div class="flow-path-container">
      <!-- <div class="big-title">
        大赛流程
      </div> -->
      <img
        class="title-txt-img"
        src="../assets/images/img_title_flow-path.png"
      />
      <div class="content">
        <!-- <div v-for="(ele, i) in flowPathArr" :key="i" class="time-wrap">
          <i v-if="i >= 1">>></i>
          <div class="left">
            <img
              :src="require(`../assets/images/time${i + 1}.png`)"
              class="time-img"
            />
            <p>{{ ele.name }}</p>
            <p>{{ ele.time1 }}</p>
            <p>{{ ele.time2 }}</p>
          </div>
        </div> -->
        <img
          :src="
            require(`../assets/images/img_flow_time${timeTnterval + 1}.png`)
          "
          class="img_flow_time"
        />
      </div>
    </div>
    <!-- 大赛组别 -->
    <div class="group-container">
      <!-- <div class="big-title">
        大赛组别
      </div> -->
      <img class="title-txt-img" src="../assets/images/img_title_group.png" />
      <div class="content">
        <div
          class="group-wrap"
          v-for="(unit, n) in homePageData.groupArr"
          :key="n"
        >
          <div class="title-box">
            <img :src="unit.img" />
            <span>{{ unit.title }}</span>
          </div>
          <div class="txt-box">
            <div class="txt-contents" v-for="(txt, t) in unit.txtArr" :key="t">
              <span class="orange-txt">{{ txt.txtTitle }}</span>
              <span>{{ txt.txtContent }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 大赛奖项 -->
    <div class="prize-container">
      <div class="top-part">
        <img class="title-txt-img" src="../assets/images/img_title_prize.png" />
      </div>
      <p class="explain">
        大赛各组别设一、二、三等奖、优秀奖及大赛特别奖，奖项及证书由第九届全国高校数字艺术设计大赛组委会颁发。除此之外，获奖者还能加入远超奖金的亿级扶持计划。
      </p>
      <img
        class="img-prize-detail"
        src="../assets/images/img_prize_detail1.png"
      />
      <!-- <img
        class="img-prize-detail2"
        src="../assets/images/img_prize_detail2.png"
      /> -->
      <div class="bottom">
        <div class="prize-box">
          <div class="title-box">
            <img src="../assets/images/prize1.png" /><span>大赛特别奖</span>
          </div>
          <div class="prize-box-content">
            <p>
              荣获全国总决赛一等奖的学生，可获得颁奖仪式现场路演的资格，角逐最终的大赛特别奖！
            </p>
            <div class="red-txt">
              <p>游戏制作组：设大赛特别奖1名，奖金高达50000元人民币；</p>
              <p>模型制作组：设大赛特别奖1名，奖金高达10000元人民币。</p>
            </div>
          </div>
        </div>
        <div class="prize-box">
          <div class="title-box">
            <img src="../assets/images/img_red_flag.png" /><span>团体奖</span>
          </div>
          <div class="prize-box-content">
            <p>
              授予学校，依据参赛校对大赛的重视程度、作品数量质量、宣传报道（在学校官网上及时转发大赛动态、报道学校组织情况、获奖情况等）、校内初选及组织工作规范度等标准评选，设卓越贡献奖、十佳组织奖、优秀组织奖。
            </p>
          </div>
        </div>
        <div class="prize-box">
          <div class="title-box">
            <img src="../assets/images/img_note.png" /><span>指导教师奖</span>
          </div>
          <div class="prize-box-content">
            <p>授予指导学生获奖的老师荣誉证书。</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 亿启星动计划 -->
    <!-- <div class="star-plain-container">
      <img class="title-txt-img" src="../assets/images/img_title_star.png" />
      <div class="content">
        <div
          class="plain-detail"
          v-for="(plain, p) in homePageData.starPlainArr"
          :key="p"
        >
          <img :src="plain.img" class="img-icon" />
          <div class="small-title">
            <span class="pink-txt">{{ plain.redTxt }}</span>
            <span>{{ plain.blackTxt }}</span>
            <img src="../assets/images/img_line.png" />
          </div>
          <p class="detail-txt">{{ plain.detailTxt }}</p>
        </div>
      </div>
    </div> -->
    <!-- gif+视频 -->
    <!-- <div class="git-container">
      <video class="video" src="../assets/images/video.mp4" controls></video>
    </div> -->
    <!-- 大赛评委 -->
    <div class="judges-container">
      <!-- <div class="big-title">
        大赛评委
      </div> -->

      <img class="title-txt-img" src="../assets/images/img_title_judges.png" />
      <!-- <p class="judges-rank-tips">以下排名不分先后</p> -->
      <div class="content">
        <div
          class="judges-box"
          v-for="(judge, j) in homePageData.judgesArr"
          :key="j"
        >
          <img
            class="img-judges"
            :src="require(`../assets/images/img_judges${j + 1}.png`)"
          />
          <!-- <div class="txt">
            <p class="name">{{ judge.name }}</p>
            <p class="position">{{ judge.position }}</p>
          </div> -->
        </div>
      </div>
    </div>
    <!-- 大赛动态 -->
    <div class="dynamic-container">
      <!-- <div class="big-title">
        大赛动态
      </div> -->
      <img class="title-txt-img" src="../assets/images/img_title_dynamic.png" />
      <div class="content">
        <div class="swipe-wrap">
          <van-swipe :autoplay="2000" :loop="true">
            <van-swipe-item v-for="(news, e) in newsImgArr" :key="e">
              <a :href="news.url">
                <img v-lazy="news.img" />
              </a>
            </van-swipe-item>
          </van-swipe>
        </div>
        <div class="news-wrap">
          <a
            :href="article.url"
            v-for="(article, a) in pagingArr[currentPage]"
            :key="a"
            class="article-link"
          >
            {{ article.text }}
          </a>
          <div class="arrow" v-if="newsArticleArr.length >= 5">
            <span
              @click="toPrePage"
              :class="currentPage === 0 ? 'gary-arrow' : 'orange-arrow'"
              >＜</span
            >
            <span
              @click="toNextPage"
              :class="
                currentPage === pagingArr.length - 1
                  ? 'gary-arrow'
                  : 'orange-arrow'
              "
              >＞</span
            >
          </div>
        </div>
      </div>
    </div>
    <!-- 大赛介绍 -->
    <div class="introduce-container">
      <!-- <div class="big-title">
        大赛介绍
      </div> -->
      <img
        class="title-txt-img"
        src="../assets/images/img_title_introduce.png"
      />
      <div class="content">
        <p v-for="(introduce, int) in homePageData.introduceArr" :key="int">
          {{ introduce }}
        </p>
      </div>
    </div>
    <!-- 合作高校 -->
    <div class="cooperation-container">
      <!-- <div class="big-title">
        合作高校
      </div> -->
      <img
        class="title-txt-img"
        src="../assets/images/img_title_cooperation.png"
      />
      <div class="content">
        <img
          :src="school"
          v-for="(school, s) in homePageData.schoolImgArr"
          :key="s"
        />
      </div>
      <p>持续更新中...</p>
    </div>
    <!-- 特别赞助 -->
    <!-- <div class="sponsorship-container">

      <img
        class="title-txt-img"
        src="../assets/images/img_title_sponsorship.png"
      />
      <div class="content">
        <img
          :src="sponsorship"
          v-for="(sponsorship, sp) in homePageData.sponsorshipImgArr"
          :key="sp"
        />
      </div>
    </div> -->
    <!-- 主办合办 -->

    <!-- <div class="btn-suspend" @click="$router.push('/works')">
      <img src="../assets/images/btn_go_apply.png" />
    </div> -->
  </div>
</template>

<script>
import { homePageData } from '../common/pageData';
export default {
  name: 'homePage',
  data() {
    return {
      homePageData: homePageData,
      newsImgArr: DATA_SHOW.banner,
      pagingArr: [],
      currentPage: 0,
      newsArticleArr: DATA_SHOW.list,
      timeTnterval: DATA_SHOW.timeStatus
    };
  },
  computed: {
    isLogin() {
      if (window.sessionStorage.getItem('currentUser') != 'null') {
        this.$store.commit(
          'userStatus',
          JSON.parse(window.sessionStorage.getItem('currentUser'))
        );
      } else {
        this.$store.commit('userStatus', null);
      }
      return this.$store.getters.isLogin;
    }
  },
  watch: {
    isLogin: function() {
      this.$reportLog(16065);
    }
  },
  created() {
    this.$reportLog(16065);
  },
  mounted() {
    window.sessionStorage.setItem(
      'pathName',
      window.location.hash.split('#')[1]
    );
    this.getPagingArr();
  },
  methods: {
    getPagingArr() {
      let num = 0;
      for (let i = 0; i < this.newsArticleArr.length; i++) {
        if (i % 5 === 0 && i !== 0) {
          this.pagingArr.push(this.newsArticleArr.slice(num, i));
          num = i;
        }
        if (i + 1 === this.newsArticleArr.length) {
          this.pagingArr.push(this.newsArticleArr.slice(num, i + 1));
        }
      }
      return this.pagingArr;
    },
    toPrePage() {
      if (this.currentPage !== 0) {
        this.currentPage--;
      }
    },
    toNextPage() {
      if (this.currentPage !== this.pagingArr.length - 1) {
        this.currentPage++;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#home-page {
  background-color: #fff;
  width: 750px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: rgb(53, 53, 53);
  font-size: 26px;
  .flow-path-container,
  .group-container,
  .prize-container,
  .star-plain-container,
  .judges-container,
  .dynamic-container,
  .introduce-container,
  .cooperation-container,
  .sponsorship-container,
  .media-company {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: rgb(88, 88, 88);
    .title-txt-img {
      width: 381px;
      height: 225px;
    }
    .title-box {
      display: flex;
      align-items: center;
      img {
        width: 94px;
        height: 65px;
      }
      span {
        font-size: 32px;
        font-weight: 800;
        margin-left: 10px;
      }
    }
  }
  .big-title {
    font-size: 60px;
    font-weight: 800;
    color: rgb(53, 53, 53);
  }

  .flow-path-container {
    width: 750px;
    height: 617px;
    background: url('../assets/images/bg_flow_path.jpg') no-repeat top
      center/750px 617px;

    .content {
      .img_flow_time {
        width: 692px;
        height: 352px;
      }
    }
  }
  .group-container {
    width: 750px;
    height: 1430px;
    background: url('../assets/images/bg_group.jpg') no-repeat top center/750px
      1430px;
    .content {
      .group-wrap {
        margin-bottom: 30px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .orange-txt {
          color: #ff874b;
          font-weight: 600;
        }

        .txt-box {
          margin-top: 20px;
          width: 709px;
          height: 480px;
          background: url('../assets/images/bg_group_txt.png') no-repeat top
            center/709px 480px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px;
        }
      }
      // .group-wrap:nth-child(2) {
      //   .txt-box {
      //     width: 709px;
      //     height: 410px;
      //     background: url('../assets/images/bg_group_txt.png') no-repeat top
      //       center/709px 410px;
      //   }
      // }
    }
  }
  .prize-container {
    padding: 0 20px;
    overflow: hidden;
    width: 750px;
    height: 2010px;
    background: url('../assets/images/bg_prize_group.jpg') no-repeat top
      center/750px 2010px;
    .explain {
      margin-top: -15px;
    }
    .img-prize-detail {
      width: 669px;
      height: 715px;
      margin-top: 10px;
    }
    .bottom {
      margin-top: 20px;
      width: 100%;
      .prize-box {
        display: flex;
        align-items: center;
        flex-direction: column;
        margin-top: 25px;
        .title-box {
          display: flex;
          span {
            font-size: 38px;
            font-weight: 600;
          }
          img {
            width: 50px;
            height: 50px;
          }
        }
      }
      .prize-box-content {
        width: 720px;
        height: 220px;
        background: url('../assets/images/bg_prize_txt.png') no-repeat top
          center/720px 220px;
        padding: 10px 15px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .red-txt {
          color: red;
        }
      }
      // .prize-box-content:nth-child(3) {
      //   width: 709px;
      //   height: 186px;
      //   background: url('../assets/images/bg_prize_txt.png') no-repeat top
      //     center/709px 186px;
      // }
    }
  }
  .star-plain-container {
    width: 750px;
    height: 906px;
    background: url('../assets/images/bg_star_plain.jpg') no-repeat top
      center/750px 906px;

    .content {
      width: 80%;
      height: 80%;
      display: flex;
      justify-content: space-around;
      align-items: center;
      flex-wrap: wrap;
      .plain-detail {
        width: 273px;
        height: 334px;
        background: url('../assets/images/bg_star_txt.png') no-repeat top
          center/273px 334px;
        display: flex;
        flex-direction: column;
        align-items: center;

        padding: 20px;

        .img-icon {
          width: 60px;
          height: 58px;
          margin-bottom: 10px;
        }
        .small-title {
          text-align: center;
          font-size: 30px;
          font-weight: 600;
          .pink-txt {
            color: #ff7f8e;
          }
          img {
            margin-top: -30px;
          }
        }
        .detail-txt {
          margin-top: -25px;
        }
      }
    }
  }
  .judges-container {
    width: 750px;
    background: url('../assets/images/bg_judges.jpg') no-repeat top center/750px
      919px;
    .judges-rank-tips {
      color: red;
      margin-top: -30px;
      margin-bottom: 10px;
    }
    .content {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      margin-bottom: 50px;
      .judges-box {
        margin: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .img-judges {
          width: 191px;
          height: 258px;
        }

        .txt {
          padding: 5px;
          display: flex;
          flex-direction: column;
          align-items: center;
          .name {
            font-size: 26px;
            font-weight: 600;
          }
          .position {
            font-size: 24px;
          }
        }
      }
    }
  }
  .dynamic-container {
    width: 750px;
    // height: 997px;
    background: url('../assets/images/bg_dynamic.jpg') no-repeat top
      center/750px 997px;
    .content {
      width: 600px;
      display: flex;
      flex-direction: column;
      align-items: center;
      border: 1px solid #ccc;
      padding: 0 10px;
      margin-bottom: 20px;
      background: #f7f7f7;

      .swipe-wrap {
        width: 590px;
        height: 318px;
        .van-swipe-item {
          z-index: 99;
          width: 590px;
          height: 318px;
        }
        .van-swipe__indicators {
          i {
            width: 10px;
            height: 10px;
            opacity: 1;
            margin-right: 10px;
          }

          .van-swipe__indicator.van-swipe__indicator--active {
            background-color: #000;
          }
        }
      }
      img {
        width: 590px;
        height: 318px;
      }
      .news-wrap {
        display: flex;
        flex-direction: column;
        align-items: center;

        .article-link {
          display: block;
          height: 60px;
          line-height: 60px;
          width: 560px;
          color: rgb(53, 53, 53);
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          border-bottom: 1px solid rgb(155, 154, 154);
          margin: 5px;
        }
        .arrow {
          width: 200px;
          // background-color: #fff;
          display: flex;
          justify-content: space-between;
          font-weight: 800;
          font-size: 50px;
          .gary-arrow {
            color: rgb(192, 190, 190);
          }
          .orange-arrow {
            color: rgb(248, 108, 73);
          }
        }
      }
    }
  }
  .introduce-container {
    width: 750px;
    height: 600px;
    background: url('../assets/images/bg_introduce.jpg') no-repeat top
      center/750px 600px;
    .content {
      padding: 20px;
      p {
        text-indent: 20px;
        line-height: 45px;
      }
    }
  }
  .cooperation-container {
    width: 750px;
    margin-bottom: 20px;
    // height: 450px;
    // background: url('../assets/images/bg_cooperation.jpg') no-repeat top
    //   center/750px 450px;
    .content {
      width: 100%;
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      img {
        width: 181px;
        height: 78px;
        margin: 20px;
        // border: 1px solid #ccc;
      }
    }
    p {
      font-size: 24px;
      margin-top: 20px;
    }
  }
  .sponsorship-container {
    width: 750px;
    height: 360px;
    background: url('../assets/images/bg_sponsorship.jpg') no-repeat top
      center/750px 360px;
    .content {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      margin-bottom: 40px;
      img {
        width: 203px;
        height: 86px;
        margin: 10px;
      }
    }
  }
}
</style>
